import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import siteLogo from "@/assets/brandLogo";

const UNIVERSAL_SOFTWARE_URL = "https://www.universal-software.com/";

export function SiteFooter() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <footer className="relative mt-auto bg-[hsl(220,40%,11%)] text-white">
      <div className="via-primary/30 h-px bg-gradient-to-r from-transparent to-transparent" />

      <div className="container">
        <div className="grid grid-cols-1 items-start gap-5 py-5 md:grid-cols-3 md:gap-8 md:py-10">
          <div className="flex flex-col items-center md:items-start">
            <button
              type="button"
              onClick={() => navigate("/")}
              className="mb-3 cursor-pointer transition-opacity hover:opacity-80"
            >
              <img
                src={siteLogo}
                alt={t("footer.orgLogoAlt")}
                className="h-14 w-auto max-w-[240px] object-contain object-left md:h-16"
              />
            </button>
            <p className="max-w-xs text-center text-base font-medium leading-relaxed text-white/70 md:text-left">
              {t("footer.blurb")}
            </p>
          </div>

          <div className="flex flex-col items-center">
            <h4 className="mb-4 text-lg font-bold uppercase tracking-wider text-white">
              {t("footer.quickLinks")}
            </h4>
            <nav className="flex flex-col items-center gap-3">
              {[
                { to: "/", label: t("nav.home") },
                { to: "/browse", label: t("footer.linkBrowseTerms") },
                { to: "/contribute", label: t("nav.contribute") },
                { to: "/search", label: t("nav.search") },
              ].map(link => (
                <button
                  key={link.to}
                  type="button"
                  onClick={() => navigate(link.to)}
                  className="hover:text-primary text-lg font-semibold text-white/90 transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="flex flex-col items-center md:items-end">
            <h4 className="mb-4 text-lg font-bold uppercase tracking-wider text-white">
              {t("footer.about")}
            </h4>
            <div className="space-y-1.5 text-center text-base font-medium md:text-right">
              <p className="text-white">
                <span className="font-semibold text-white">
                  {t("footer.advisorLabel")}
                </span>{" "}
                <span className="text-white/95">Dr. Jitendra B. Shah</span>
              </p>
              <p className="text-white">
                <span className="font-semibold text-white">
                  {t("footer.editorLabel")}
                </span>{" "}
                <span className="text-white/95">Dilip V. Shah</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-white/8 space-y-4 border-t py-5">
          <p className="flex flex-wrap items-center justify-center gap-2 text-center text-sm font-medium text-white/60">
            <span>{t("footer.developedBy")}</span>
            <Button
              asChild
              variant="outline"
              size="sm"
              className="h-8 border-white/35 bg-white/5 px-3 text-white/95 hover:border-white/50 hover:bg-white/10 hover:text-white"
            >
              <a
                href={UNIVERSAL_SOFTWARE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("footer.universalSoftware")}
              </a>
            </Button>
          </p>
          <div className="flex flex-col items-center justify-between gap-3 sm:flex-row">
            <p className="text-sm font-medium text-white/60">
              {t("footer.copyright", { year: new Date().getFullYear() })}
            </p>
            <p className="mb-4 text-sm font-medium text-white/50 sm:mb-0">
              {t("footer.preserving")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
